module.exports = __webpack_public_path__ + "static/img/task_appraise_4.cd4ed265.png";